function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1900(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 44.64,
    height: 27.58,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.895
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 13.79
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 27.58,
    width: 44.64,
    height: 27.96,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 41.56
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 55.54,
    width: 44.64,
    height: 29.95,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.4875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 70.515
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 85.48,
    width: 44.64,
    height: 31.86,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.551428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 101.41
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 117.34,
    width: 44.64,
    height: 36.44,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 135.56
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 153.78,
    width: 44.64,
    height: 38.76,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.46
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 173.16
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 192.54,
    width: 44.64,
    height: 42.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.7225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 213.98499999999999
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 235.43,
    width: 44.64,
    height: 43.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.608333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 257.08
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 278.74,
    width: 44.64,
    height: 44.81,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.96
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 301.145
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 323.54,
    width: 44.64,
    height: 49.38,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.928
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 348.23
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 372.93,
    width: 44.64,
    height: 49.76,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.377142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 397.81
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 422.69,
    width: 44.64,
    height: 51.11,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.96
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 448.245
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 473.8,
    width: 44.64,
    height: 51.45,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.96
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 499.52500000000003
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 525.24,
    width: 44.64,
    height: 51.48,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.928
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 550.98
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 576.73,
    width: 44.64,
    height: 60.72,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.464
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 607.09
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 637.45,
    width: 44.64,
    height: 62.55,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.16
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 668.725
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.64,
    y: 0,
    width: 49.57,
    height: 56.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.957
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.425,
    y: 28.32
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.21,
    y: 0,
    width: 49.89,
    height: 56.64,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.315
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.155,
    y: 28.32
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.1,
    y: 0,
    width: 49.95,
    height: 56.64,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 169.075,
    y: 28.32
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 194.05,
    y: 0,
    width: 51.4,
    height: 56.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.711111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 219.75,
    y: 28.32
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 245.45,
    y: 0,
    width: 52.43,
    height: 56.64,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.55375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 271.66499999999996,
    y: 28.32
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 297.88,
    y: 0,
    width: 53.74,
    height: 56.64,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.7175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 324.75,
    y: 28.32
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 351.62,
    y: 0,
    width: 54.12,
    height: 56.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.02
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 378.68,
    y: 28.32
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 405.74,
    y: 0,
    width: 57.28,
    height: 56.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.08
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 434.38,
    y: 28.32
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 463.02,
    y: 0,
    width: 57.37,
    height: 56.64,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.44
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 491.705,
    y: 28.32
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 520.4,
    y: 0,
    width: 59.62,
    height: 56.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.328
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 550.2099999999999,
    y: 28.32
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 580.02,
    y: 0,
    width: 59.77,
    height: 56.64,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 609.905,
    y: 28.32
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 639.79,
    y: 0,
    width: 60.21,
    height: 56.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.44
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 669.895,
    y: 28.32
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.64,
    y: 56.64,
    width: 62.13,
    height: 55.19,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.884285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.705,
    y: 84.235
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.64,
    y: 111.83,
    width: 62.13,
    height: 55.41,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.92625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.705,
    y: 139.535
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.64,
    y: 167.24,
    width: 62.13,
    height: 55.46,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.243333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.705,
    y: 194.97
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.64,
    y: 222.7,
    width: 62.13,
    height: 55.79,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.97375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.705,
    y: 250.595
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.64,
    y: 278.49,
    width: 62.13,
    height: 57.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.459999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.705,
    y: 307.14
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.64,
    y: 335.79,
    width: 62.13,
    height: 57.89,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.705,
    y: 364.735
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.64,
    y: 393.68,
    width: 62.13,
    height: 58.35,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.67
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.705,
    y: 422.855
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.64,
    y: 452.02,
    width: 62.13,
    height: 59.64,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.94
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.705,
    y: 481.84
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.64,
    y: 511.67,
    width: 62.13,
    height: 62.2,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.648181818181818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.705,
    y: 542.77
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.64,
    y: 573.87,
    width: 62.13,
    height: 62.39,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.355
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.705,
    y: 605.065
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.64,
    y: 636.26,
    width: 62.13,
    height: 63.74,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.875714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.705,
    y: 668.13
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.77,
    y: 56.64,
    width: 64.22,
    height: 63.87,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.98375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.88,
    y: 88.575
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.99,
    y: 56.64,
    width: 64.38,
    height: 63.87,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.096666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 203.18,
    y: 88.575
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.37,
    y: 56.64,
    width: 64.59,
    height: 63.87,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.98375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.665,
    y: 88.575
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.97,
    y: 56.64,
    width: 64.99,
    height: 63.87,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.387
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 332.46500000000003,
    y: 88.575
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 364.95,
    y: 56.64,
    width: 65.93,
    height: 63.87,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.774
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 397.91499999999996,
    y: 88.575
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 430.88,
    y: 56.64,
    width: 66.45,
    height: 63.87,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.774
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 464.105,
    y: 88.575
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 497.33,
    y: 56.64,
    width: 66.66,
    height: 63.87,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.124285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 530.66,
    y: 88.575
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 564,
    y: 56.64,
    width: 67.27,
    height: 63.87,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.645
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 597.635,
    y: 88.575
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 631.26,
    y: 56.64,
    width: 68.74,
    height: 63.87,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.124285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 665.63,
    y: 88.575
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.77,
    y: 120.52,
    width: 64.77,
    height: 68.22,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.09625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.155,
    y: 154.63
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.77,
    y: 188.74,
    width: 64.77,
    height: 69.2,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.953999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.155,
    y: 223.34
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.77,
    y: 257.94,
    width: 64.77,
    height: 69.56,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.795
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.155,
    y: 292.72
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.77,
    y: 327.5,
    width: 64.77,
    height: 71.04,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.795
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.155,
    y: 363.02
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.77,
    y: 398.54,
    width: 64.77,
    height: 73.96,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.09625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.155,
    y: 435.52000000000004
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.77,
    y: 472.5,
    width: 64.77,
    height: 75.18,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.795
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.155,
    y: 510.09000000000003
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.77,
    y: 547.68,
    width: 64.77,
    height: 75.25,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.795
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.155,
    y: 585.305
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.77,
    y: 622.94,
    width: 64.77,
    height: 77.06,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.795
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.155,
    y: 661.47
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.54,
    y: 120.52,
    width: 68.99,
    height: 73.11,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.855714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 206.035,
    y: 157.075
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240.53,
    y: 120.52,
    width: 72.54,
    height: 73.11,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.090000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 276.8,
    y: 157.075
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 313.08,
    y: 120.52,
    width: 74.26,
    height: 73.11,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.185
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 350.21,
    y: 157.075
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 387.34,
    y: 120.52,
    width: 75.43,
    height: 73.11,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.444285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 425.05499999999995,
    y: 157.075
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 462.77,
    y: 120.52,
    width: 78.23,
    height: 73.11,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.444285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 501.885,
    y: 157.075
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541,
    y: 120.52,
    width: 79.1,
    height: 73.11,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.2775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 580.55,
    y: 157.075
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620.1,
    y: 120.52,
    width: 79.9,
    height: 73.11,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.185
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 660.0500000000001,
    y: 157.075
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.54,
    y: 193.62,
    width: 83.86,
    height: 70.51,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.751666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.47,
    y: 228.875
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.54,
    y: 264.13,
    width: 83.86,
    height: 71.49,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.9433333333333325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.47,
    y: 299.875
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.54,
    y: 335.63,
    width: 83.86,
    height: 71.49,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.499090909090909
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.47,
    y: 371.375
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.54,
    y: 407.12,
    width: 83.86,
    height: 72.21,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.034999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.47,
    y: 443.225
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.54,
    y: 479.33,
    width: 83.86,
    height: 72.81,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.401428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.47,
    y: 515.735
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.54,
    y: 552.14,
    width: 83.86,
    height: 72.85,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.569999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.47,
    y: 588.5649999999999
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.54,
    y: 624.99,
    width: 83.86,
    height: 75.01,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.715714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.47,
    y: 662.495
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.4,
    y: 193.62,
    width: 86.43,
    height: 75.41,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.378888888888888
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 298.615,
    y: 231.325
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.83,
    y: 193.62,
    width: 87.45,
    height: 75.41,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.8525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 385.555,
    y: 231.325
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 429.28,
    y: 193.62,
    width: 89.12,
    height: 75.41,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.568333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 473.84,
    y: 231.325
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 518.39,
    y: 193.62,
    width: 90.25,
    height: 75.41,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.5409999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 563.515,
    y: 231.325
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 608.64,
    y: 193.62,
    width: 91.36,
    height: 75.41,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.5409999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 654.3199999999999,
    y: 231.325
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.4,
    y: 269.03,
    width: 82.28,
    height: 83.78,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 296.54,
    y: 310.91999999999996
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.4,
    y: 352.81,
    width: 82.28,
    height: 85.45,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 296.54,
    y: 395.535
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.4,
    y: 438.26,
    width: 82.28,
    height: 85.86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 296.54,
    y: 481.19
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.4,
    y: 524.12,
    width: 82.28,
    height: 87.34,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.456
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 296.54,
    y: 567.79
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.4,
    y: 611.46,
    width: 82.28,
    height: 88.54,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.456
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 296.54,
    y: 655.73
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.68,
    y: 269.03,
    width: 89.72,
    height: 82.48,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.746666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 382.54,
    y: 310.27
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.4,
    y: 269.03,
    width: 89.84,
    height: 82.48,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.782857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 472.32,
    y: 310.27
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 517.24,
    y: 269.03,
    width: 90.43,
    height: 82.48,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.31
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 562.455,
    y: 310.27
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 607.68,
    y: 269.03,
    width: 92.32,
    height: 82.48,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.746666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 653.8399999999999,
    y: 310.27
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.68,
    y: 351.52,
    width: 91.22,
    height: 85.3,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.477777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 383.29,
    y: 394.16999999999996
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.68,
    y: 436.82,
    width: 91.22,
    height: 85.3,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.185714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 383.29,
    y: 479.46999999999997
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.68,
    y: 522.12,
    width: 91.22,
    height: 87.76,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.97
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 383.29,
    y: 566
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.68,
    y: 609.89,
    width: 91.22,
    height: 90.11,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.011
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 383.29,
    y: 654.9449999999999
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 428.89,
    y: 351.52,
    width: 89.9,
    height: 94.97,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.842857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 473.84,
    y: 399.005
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 518.79,
    y: 351.52,
    width: 90.06,
    height: 94.97,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.012
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 563.8199999999999,
    y: 399.005
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 608.85,
    y: 351.52,
    width: 91.15,
    height: 94.97,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.39375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 654.4250000000001,
    y: 399.005
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 428.89,
    y: 446.49,
    width: 117.08,
    height: 78.06,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.515
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 487.43,
    y: 485.52
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 428.89,
    y: 524.56,
    width: 117.08,
    height: 87.25,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.931818181818182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 487.43,
    y: 568.185
  }, "\n        Mecklenburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 428.89,
    y: 611.81,
    width: 117.08,
    height: 88.19,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.598571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 487.43,
    y: 655.905
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 545.97,
    y: 446.49,
    width: 154.03,
    height: 72.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 622.985,
    y: 482.79
  }, "\n        Guilford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 545.97,
    y: 519.09,
    width: 154.03,
    height: 85.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.7375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 622.985,
    y: 562.0400000000001
  }, "\n        Buncombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 545.97,
    y: 605,
    width: 154.03,
    height: 95,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 622.985,
    y: 652.5
  }, "\n        Wake\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1900);
export default __webpack_public_path__ + "static/media/1900.cd636bfcd8a84d1c604cd38fd4d20aef.svg";
export { ForwardRef as ReactComponent };